import store from "@/store"
import LoginPage from "@/views/Login"
import Reservas from "@/views/Administrador/Reservas"
import Salas from "@/views/Administrador/Salas"
import VerSala from "@/views/VerSala"
import Relatorios from "@/views/Administrador/Relatorios"
import FormularioSala from "@/views/Administrador/FormularioSala"
import FormularioBloco from "@/views/Administrador/FormularioBloco"
import router from "@/router/index"
import CriarReserva from "@/views/Administrador/CriarReserva"
import Blocos from "@/views/Administrador/Blocos"
import AcessoNegado from "@/views/AcessoNegado"
import SistemaIndisponivel from "@/views/SistemaIndisponivel"
import PaginaNaoEncontrada from "@/views/PaginaNaoEncontrada"
import CancelarDiasReserva from "@/views/CancelarDiasReserva"
import Cadastro from "@/views/Cadastro"
import RecuperarSenha from "@/views/RecuperarSenha"
import NovaSenha from "@/views/NovaSenha"
import DadosPessoais from "@/views/DadosPessoais"

export default [
  {
    path: "/",
    name: "home",
    redirect: "/reservas",
  },
  {
    path: "/reservas",
    name: "reservas",
    component: Reservas,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reservas/nova",
    name: "criarReserva",
    component: CriarReserva,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reservas/:id/cancelar",
    name: "cancelarDiasReserva",
    props: true,
    component: CancelarDiasReserva,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reservas/:id",
    name: "editarReserva",
    props: true,
    component: CriarReserva,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/salas",
    name: "salas",
    component: Salas,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/salas/nova",
    name: "criarSala",
    component: FormularioSala,
    meta: {
      requiresAuth: true,
      permissions: [
        {
          role: "ADMINISTRADOR",
          access: true,
        },
      ],
    },
  },
  {
    path: "/relatorios",
    name: "relatorioSala",
    component: Relatorios,
    meta: {
      requiresAuth: true,
      permissions: [
        {
          role: "ADMINISTRADOR",
          access: true,
        },
      ],
    },
  },
  {
    path: "/salas/:id/editar",
    name: "editarSala",
    component: FormularioSala,
    props: true,
    meta: {
      requiresAuth: true,
      permissions: [
        {
          role: "ADMINISTRADOR",
          access: true,
        },
        {
          role: "PREFEITURA",
          access: true,
        },
      ],
    },
  },
  {
    path: "/salas/:id/mostrar",
    name: "verSala",
    component: VerSala,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/blocos",
    name: "blocos",
    component: Blocos,
    meta: {
      requiresAuth: true,
      permissions: [
        {
          role: "ADMINISTRADOR",
          access: true,
        },
      ],
    },
  },
  {
    path: "/blocos/novo",
    name: "criarBloco",
    meta: {
      requiresAuth: true,
      permissions: [
        {
          role: "ADMINISTRADOR",
          access: true,
        },
      ],
    },
    component: FormularioBloco,
  },
  {
    path: "/blocos/:id/editar",
    name: "editarBloco",
    props: true,
    meta: {
      requiresAuth: true,
      permissions: [
        {
          role: "ADMINISTRADOR",
          access: true,
        },
      ],
    },
    component: FormularioBloco,
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    props: true,
    meta: {
      public: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: { breadcrumb: true },
    beforeEnter() {
      store.dispatch("auth/removeToken", false).then(() => {
        router.push({ name: "login" })
      })
    },
  },
  {
    path: "/cadastro",
    name: "cadastro",
    component: Cadastro,
    meta: {
      public: true,
    },
  },
  {
    path: "/confirmar-email",
    name: "confirmacao",
    redirect: () => ({ path: "/login", query: { confirmado: true } }),
  },
  {
    path: "/recuperar-senha",
    name: "esqueci",
    component: RecuperarSenha,
    meta: {
      public: true,
    },
  },
  {
    path: "/nova-senha",
    name: "novaSenha",
    component: NovaSenha,
    meta: {
      public: true,
    },
  },
  {
    path: "/acessoNegado",
    name: "acessoNegado",
    component: AcessoNegado,
    meta: {
      public: true,
    },
  },
  {
    path: "/sistemaIndisponivel",
    name: "sistemaIndisponivel",
    component: SistemaIndisponivel,
    meta: {
      public: true,
    },
  },
  {
    path: "/dadosPessoais",
    name: "dadosPessoais",
    component: DadosPessoais,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "*",
    name: "paginaNaoEncontrada",
    component: PaginaNaoEncontrada,
    meta: {
      public: true,
    },
  },
]
